import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
export default {
  options: function options(state) {
    return state.options;
  },
  information: function information(state) {
    return state.information;
  },
  encodedCustomizable: function encodedCustomizable(state) {
    return state.encodedCustomizable;
  },
  customizable: function customizable(state) {
    return state.customizable;
  },
  selectedOption: function selectedOption(state) {
    return state.selectedOption;
  },
  configurator: function configurator(state) {
    return state.configurator;
  },
  price: function price(state) {
    return state.price;
  }
};